import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    input: {
        backgroundColor: "transparent",
        textAlignVertical: "center",
        includeFontPadding: false,
        alignSelf: "stretch",
        borderWidth: 0,
        minWidth: 0,
        padding: 0,
        margin: 0,
        flex: 1
    }
});
export default stylesheet;
